module.exports = __webpack_public_path__ + "img/DavidLaFalce@2x.8ca10da9.png";